import api from "./client";

export async function fetchPortofolios() {
  const { data } = await api.get("/api/portofolio");
  return data.data ?? data;
}

export async function insertPortofolio(payload) {
  const { data } = await api.post("/api/portofolio", payload);
  return data;
}

export async function updatePortofolio(id, payload) {
  const { data } = await api.put(`/api/portofolio/${id}`, payload);
  return data;
}

export async function deletePortofolio(id) {
  await api.delete(`/api/portofolio/${id}`);
}

export async function fetchPortofolioCategories() {
  const { data } = await api.get("/api/portofolio/categories");
  return data;
}

export async function togglePortofolioFeatured(id) {
  const { data } = await api.patch(`/api/portofolio/${id}/featured`);
  return data;
}
